
  import { mapGetters } from 'vuex'
  const LOTTERY_NUMBER_LENGTH = 6
  export default {
    computed: {
      ...mapGetters({
        lotteryWinner: 'cms/lotteryWinner'
      }),
      count() {
        // Defensive: handle missing or invalid number
        const num = this.lotteryWinner?.number
        const numberString = num?.toString().padStart(LOTTERY_NUMBER_LENGTH, '0')
        return numberString.split('')
      },
      visibleWinners() {
        // Defensive: handle missing items
        return Array.isArray(this.lotteryWinner?.items)
          ? this.getVisibleItems(this.lotteryWinner.items)
          : []
      }
    },
    methods: {
      // Utility for color style
      getNumberStyle(index, total) {
        return {
          'border-left': index !== 0 ? '1px solid #c64751' : '',
          color: index < total / 2 ? 'red' : ''
        }
      }
    }
  }
